import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fit-cat/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/fit-cat',
  name: 'activity_fit_cat',
  component: Index,
  props: true,
  meta: {
    title: 'Fit猫',
  },
}

export default [indexRoute]
